<script>
export default {
}
</script>
<template>
  <icon-base>
    <g>
      <g id="document">
        <path d="M 4 18 h 12 V 6 h -4 V 2 H 4 v 16 z m -2 1 V 0 h 12 l 4 4 v 16 H 2 v -1 z" />
      </g>
      <g id="magnifier">
        <path transform="matrix(0.6,0,0,0.6,5.1,4.2)" d="M 12.1 16.9 C 8.8 19.5 4 19.1 1.2 15.9 C -1.6 12.8 -1.5 8 1.5 5 C 4.5 2 9.3 1.8 12.5 4.6 C 15.7 7.4 16.1 12.2 13.5 15.5 l 5.3 5.3 l -1.4 1.4 l -5.3 -5.3 z M 7.2 16.6 C 10.5 16.6 13.2 14 13.2 10.6 C 13.2 7.3 10.5 4.6 7.2 4.6 C 3.9 4.6 1.2 7.3 1.2 10.6 C 1.2 14 3.9 16.6 7.2 16.6 z" />
      </g>
    </g>
  </icon-base>
</template>